var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Medal, Prize, Reward.5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14046",
    fill: "none",
    stroke: "#1ea019",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11771",
    d: "M12 22v-1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11772",
    d: "M5.69 20.31l.62-.62"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11773",
    d: "M19.5 14h1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11774",
    d: "M3.5 14h1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11775",
    d: "M17.69 19.69l.62.62"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11776",
    d: "M14.946 11.054a4.167 4.167 0 11-5.893 0 4.167 4.167 0 015.893 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11777",
    d: "M16.43 6H7.57"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11778",
    d: "M15.676 12.078L19.492 7.8A2 2 0 0020 6.469V4a2.006 2.006 0 00-2-2H6a2 2 0 00-2 2v2.469A2 2 0 004.508 7.8l3.816 4.278"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11779",
    d: "M4.57 2.63l6.51 7.31"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11780",
    d: "M19.43 2.63l-6.51 7.31"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11781",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgStep9;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Americo/icons/step_9.svg
// module id = 7673
// module chunks = 13